import { toast } from "sonner";

const SITE_WIN = "snaplist-site";

export const deviceKind = () => {
  const coarse = window.matchMedia("(pointer: coarse)").matches;
  if (!coarse && window.screen.availWidth >= 1000) return "computer";
  return Math.min(window.screen.width, window.screen.height) >= 600 ? "tablet" : "phone";
};

const APP_WIN = "snaplist-app";
const SPLIT_KEY = "snaplist.sbsSplit";
export const SPLITS = { half: 0.5, narrow: 0.34 };

export const getSplit = () => {
  try { return SPLITS[localStorage.getItem(SPLIT_KEY)] ? localStorage.getItem(SPLIT_KEY) : "half"; } catch { return "half"; }
};
export const setSplit = (v) => { try { localStorage.setItem(SPLIT_KEY, v); } catch { /* ignore */ } };
const SIDE_KEY = "snaplist.sbsSide";
export const getAppSide = () => { try { return localStorage.getItem(SIDE_KEY) === "right" ? "right" : "left"; } catch { return "left"; } };
export const setAppSide = (v) => { try { localStorage.setItem(SIDE_KEY, v); } catch { /* ignore */ } };
const appWidth = () => Math.round(window.screen.availWidth * SPLITS[getSplit()]);
const appLeft = () => (getAppSide() === "right" ? window.screen.availWidth - appWidth() : 0);
const siteLeft = () => (getAppSide() === "right" ? 0 : appWidth());
const features = (left, width) => `popup,left=${left},top=0,width=${width},height=${window.screen.availHeight}`;

// Computer: puts the posting site beside SnapList (SnapList left by default, swappable) (half, or about a third when narrow).
export const openSiteWindow = (url) => {
  if (!url) return null;
  if (deviceKind() !== "computer") return window.open(url, "_blank", "noopener");
  const win = window.open(url, SITE_WIN, features(siteLeft(), window.screen.availWidth - appWidth()));
  if (!win) toast.error("Allow pop-ups for SnapList so it can open the site beside it");
  else win.focus();
  return win;
};

// One tap from Quick paste. Computer: two new windows filling the screen — SnapList's copy queue on the left, the site on the right.
// Browsers can't move the current tab, so it stays behind them. Phones/tablets: switch this tab to the copy queue.
export const startSideBySide = (navigate, draftId, channel, sellUrl) => {
  const path = `/side-by-side/${draftId}?channel=${channel}`;
  if (deviceKind() !== "computer") return navigate(path);
  const app = window.open(`${path}&arranged=1`, APP_WIN, features(appLeft(), appWidth()));
  if (!app) {
    toast.error("Allow pop-ups for SnapList to open both windows side by side");
    return navigate(path);
  }
  const site = sellUrl ? openSiteWindow(sellUrl) : null;
  if (!sellUrl || site) app.focus();
  return undefined;
};

// Header "List on a site": SnapList (this page) and the site as two windows filling the screen, in one click.
export const openSideBySidePair = (appPath, sellUrl) => {
  if (deviceKind() !== "computer") return window.open(sellUrl, "_blank", "noopener");
  if (window.name !== APP_WIN) {
    const app = window.open(appPath, APP_WIN, features(appLeft(), appWidth()));
    if (!app) { toast.error("Allow pop-ups for SnapList to open both windows side by side"); return null; }
  }
  return openSiteWindow(sellUrl);
};
